import { useEffect, useState } from "react";

const useKeyGenerate = () => {
	const [key, setKey] = useState("");

	useEffect(() => {
		var lR = keygen();
		var tR = keygen();

		var t = Math.floor(Date.now() / 1000);

		setKey(lR.toString() + t.toString() + tR.toString());
	}, []);

	const keygen = () => {
		return Math.floor(1000 + Math.random() * 9000);
	};

	return key;
};

export default useKeyGenerate;
